module.exports = __webpack_public_path__ + "static/media/job-seekers.730a0d1e.svg";